Deletes an uploaded candidate and their profile from SEEK's systems.

This will also delete all `CandidateProcessHistoryItem`s belonging to the candidate profile.
